import React from 'react';
import cl from "./SubscriptionCancellationsPageMenuItem.module.css";

const SubscriptionCancellationsPageMenuItem = ({id, title, selected, onClick}) => {
    return (
        <button
            className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
            onClick={onClick}
        >
            <span className={cl.title}>{title}</span>
        </button>
    );
};

export default SubscriptionCancellationsPageMenuItem;